import LabServiceCollection from "@/collections/LabServiceCollection";
import SampleTestPackageModel from "@/models/lab/SampleTestPackageModel";

export default class SampleTestPackageCollection extends LabServiceCollection {
  model() {
    return SampleTestPackageModel;
  }

}
